/* eslint-disable react-hooks/exhaustive-deps */
import { HeaderUser } from './components/header-user.component';
import styles from './components/styles/header-user-styles.module.css';
import { useUserProfile } from './hooks/useUserProfile';
import { Box, Paper, Tabs, Tab } from '@mui/material';

export const UserProfile = () => {
	const {
		userInfo,
		currentTab,
		tabItems,
		matches,
		setCurrentTab,
		setStep,
		getComponent,
	} = useUserProfile();

	return (
		<Box className={styles.profileWrapper}>
			<Paper elevation={0} className={styles.headerCard}>
				<HeaderUser user={userInfo} />

				<Box className={styles.tabsContainer}>
					<Tabs
						value={currentTab}
						onChange={(_, value) => {
							setCurrentTab(value);
							setStep(value);
						}}
						TabIndicatorProps={{
							style: { background: 'var(--color-primary-main, #744cb4)' },
						}}
						sx={{
							px: { xs: 2, md: 4 },
							'& button.Mui-selected': {
								color: 'var(--color-primary-main, #744cb4)',
							},
						}}
						orientation={matches ? 'vertical' : 'horizontal'}
					>
						{(tabItems || []).map((element, index: number) => {
							return (
								<Tab
									key={index}
									id={`tab-${element.label
										.replaceAll(' ', '-')
										.toLowerCase()}`}
									className={styles.tabsStyle}
									label={element.label}
								/>
							);
						})}
					</Tabs>
				</Box>
			</Paper>

			<Box className={styles.contentCard}>{getComponent()}</Box>
		</Box>
	);
};
